import { render, staticRenderFns } from "./TerminateEmployeeModal.vue?vue&type=template&id=13fa2bfe&scoped=true&"
import script from "./TerminateEmployeeModal.vue?vue&type=script&lang=js&"
export * from "./TerminateEmployeeModal.vue?vue&type=script&lang=js&"
import style0 from "./TerminateEmployeeModal.vue?vue&type=style&index=0&id=13fa2bfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fa2bfe",
  null
  
)

component.options.__file = "TerminateEmployeeModal.vue"
export default component.exports